<template>
  <div id="tenant-settings-wrapper">
    <h1 class="settings-title">
      {{getTenant.name}}
    </h1>
    <vue-tabs
      activeTextColor="#09a3ed"
      v-if="tenant"
    >
      <v-tab title="My Business">
        <div class="inner-tab">
          <form v-if="tenant" @submit.prevent="submitBusinessProfile">
            <div>
              <h4>
                Business Name
              </h4>
              <p>
                The name of your business or company.
              </p>
              <input
                type="text"
                v-model="tenant.name"
              />
            </div>
            <div>
              <h4>
                Business Domain
              </h4>
              <p>
                The host domain associated with your business. This value cannot be edited.
              </p>
              <input
                disabled
                class="disabled"
                type="text"
                :value="tenant.domain"
              />
            </div>
            <div>
              <h4>
                Business Logo
              </h4>
              <p>
                The logo of your business or company.
              </p>
              <button class="button__action">Choose New Image</button>
              <img
                :src="getTenant.icon"
                class="tenantLogo"
              />
            </div>
            <button class="button__submit" type="submit">Save Changes</button>
          </form>
        </div>
      </v-tab>

      <v-tab title="Users">
        <div class="inner-tab">
          <button class="button__action" id="cold-deck-button" @click="toggleModal('coldDeck')">Reset App User Deck</button>
          <button class="button__action" id="new-user-button" @click="toggleModal('manageUser')">+ New Admin User</button>
          <h2>
            All Users
          </h2>
          <ul
            class="user-list"
            v-if="tenantUsers"
          >
            <li
              v-for="(user, index) in tenantUsers"
              class="user-item"
            >
              <Avatar
                :username="getUserName(user.profile.name)"
                color="#ccc"
                backgroundColor="#2b4663"
                :size="40"
                :style="{ flex: '0 0 auto', borderRadius: '10px', marginRight: '30px' }"
              />
              <h4>
                {{ user.profile.name.first}} {{ user.profile.name.last }}
              </h4>
              <p>{{ user.primary_email }}</p>
              <span
                class="user-role-tag"
                v-if="user.role"
              >
                {{ user.role.title }}
              </span>
              <button class="button__action manage-user" @click="resetPassword(user)">Reset Password</button>
              <button class="button__action manage-user" @click="toggleModal('manageUser', user)">Manage User</button>
            </li>
          </ul>
        </div>
      </v-tab>
      <v-tab title="Roles">
        <div class="inner-tab">
          <button class="button__action" id="new-user-button" @click="toggleModal('manageRole')">+ New Role</button>
          <h2>
            All Roles
          </h2>
          <ul
            class="user-list"
            v-if="tenantRoles"
          >
            <li
              v-for="(role, index) in tenantRoles"
              class="user-item"
            >
              <h4>
                {{ role.title }}
              </h4>
              <button
                class="button__action manage-user"
                @click="toggleModal('manageRole', role)"
              >
                Manage Role
              </button>
            </li>
          </ul>
        </div>
      </v-tab>
    </vue-tabs>
    <ManageRoleModal
      v-if="showManageRoleModal"
      :selectedRole="selectedRole"
      :refreshRoles="refreshRoles"
      :close="toggleModal"
    />
    <ManageUserModal
      v-if="showManageUserModal"
      :selectedUser="selectedUser"
      :refreshUsers="refreshUsers"
      :roles="tenantRoles"
      :close="toggleModal"
    />
  </div>
</template>
<script>
import Services from '../../services/Services';
import store from '../../store';
import Spinner from '../general/Spinner';
import {VueTabs, VTab} from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/paper.css';
import Avatar from 'vue-avatar';
import { postResource } from '../../services/Utils';
import VueNotifications from 'vue-notifications';
import ManageRoleModal from '../modals/ManageRole.vue';
import ManageUserModal from '../modals/ManageUser.vue';

export default {
  name: 'tenantSettings',
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: '',
      icon: '❗️'
    }
  },
  components: {
    Avatar,
    ManageRoleModal,
    ManageUserModal,
    Spinner,
    VueTabs,
    VTab,
  },
  computed: {
    getTenant() {
      const tenant = store.getters.getTenant;
      if (!this.tenantSet && tenant._id) {
        this.tenant =  { ...tenant };
        this.tenantSet = true;
      }
      return tenant;
    },
  },
  data() {
    return {
      tenant: {
        name: '',
        domain: '',
      },
      tenantSet: false,
      tenantUsers: null,
      tenantRoles: null,
      selectedRole: null,
      selectedUser: null,
      showManageRoleModal: false,
      showManageUserModal: false,
    }
  },
  methods: {
    submitBusinessProfile() {
      console.log(this.tenant);
    },
    getUserName(name) {
      const p = `${name.first} ${name.last}`;
      return p;
    },
    resetPassword(user) {
        const domain = store.getters.getDomain;
        const email = user.primary_email;
        const tenantId = store.getters.getTenant._id;

        postResource('/v1/auth/reset/1', '', {
            email,
            domain,
            tenantId
        })
        .then(res => {
          this.showSuccessMsg({
            message: `Password email link sent!`
        });
        })
        .catch(err => console.log(err));
    },
    isTenantAdmin(id) {
      const admins = store.getters.getTenant.admins;
      if (admins) return admins.includes(id);
    },
    toggleModal(modal, data) {
      if (modal === 'manageRole') {
        if (data) {
          this.selectedRole = data;
        } else {
          this.selectedRole = null; // resets data on toggle close
          // create new role
        }
        this.showManageRoleModal = !this.showManageRoleModal;
      } else if (modal === 'manageUser') {
          if(data) {
              this.selectedUser = data;
          } else {
              this.selectedUser = null;
          }
          this.showManageUserModal = !this.showManageUserModal;
      } else if (modal === 'coldDeck') {
        store.commit('showColdDeckModal', true);
      }
    },
    refreshRoles() {
      Services.getTenantRoles()
        .then(roles => (this.tenantRoles = roles))
        .catch(err => console.log(err));
    },
    refreshUsers() {
      Services.getTenantUsers()
        .then(users => (this.tenantUsers = users))
        .catch(err => console.log(err));
    },
  },
  mounted() {
    Services.getTenantUsers()
      .then(users => (this.tenantUsers = users.sort((a, b) => (b.profile.name.first < a.profile.name.first))))
      .catch(err => console.log(err));
    Services.getTenantRoles()
      .then(roles => (this.tenantRoles = roles))
      .catch(err => console.log(err));
  }
}
</script>

<style lang="scss">
#tenant-settings-wrapper {
  padding: 30px;
  box-sizing: border-box;
  background: #f5f5f5;
  min-height: 100vh;
  h1.settings-title {
    margin: 30px 0;
    color: #555;
  }
  .vue-tabs .nav-tabs-navigation {
    margin-bottom: 0;
  }
  .inner-tab {
    background: #fff;
    border-bottom: 1px solid #eee;
    border-left: 1px solid #eee;
    border-right: 1px solid #eee;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    box-sizing: border-box;
    padding: 10px 30px 30px;

    form {
      div {
        padding: 30px 0;
        box-sizing: border-box;
        border-bottom: 1px solid #eee;
        h4 {
          margin: 0 0;
        }
        p {
          color: #888;
        }
        input {
          padding: 10px;
          border-radius: 4px;
          border: 1px solid #ddd;
          width: 100%;
          max-width: 600px;
          font-size: 1em;

          &.disabled {
            background: #f5f5f5;
            color: #555;
          }
        }
        img.tenantLogo {
          max-width: 150px;
          padding: 10px;
          border-radius: 5px;
          box-sizing: border-box;
          border: 1px solid #eee;
        }

        button.button__action {
          margin: 15px 0;
        }
      }
      button.button__submit {
        margin-top: 30px;
      }
    }

    button.button__action {
      float: right;
      position: relative;
      top: 15px;
    }

    ul.user-list {
      display: flex;
      flex-flow: column nowrap;
      width: 100%;
      list-style: none;
      margin: 0;
      padding: 0;

      li.user-item {
        flex: 0 0 auto;
        margin: 0;
        border-top: 1px solid #ddd;
        display: flex;
        flex-flow: row nowrap;
        padding: 15px;

        h4 {
          font-size: 1em;
          margin: auto 15px auto 0;
          padding: 0;
        }
        p {
          font-size: 1em;
          color: #888;
          margin: auto 15px;
        }
        span.user-role-tag {
          font-size: 0.9em;
          color: #aaa;
          border: 1px solid #ddd;
          margin: auto auto auto 15px;
          border-radius: 50px;
          padding: 4px 8px;
        }
        button.manage-user {
          margin: auto 0 auto 10px;
          border-color: #aaa;
          color: #aaa;
          opacity: 0;
          pointer-events: none;
        }

        &:hover {
          background: #f5f5f5;
          button.manage-user {
            opacity: 1;
            pointer-events: auto;
          }
        }
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/TenantSettings.vue